export default "__VITE_ASSET__DHQPuzit__"